module.exports = __webpack_public_path__ + "static/media/footer-logo-creation.4cbbbbd4.webp";